import { render, staticRenderFns } from "./class-inactive.view.vue?vue&type=template&id=6a7a474c&scoped=true&"
import script from "./class-inactive.view.ts?vue&type=script&lang=ts&"
export * from "./class-inactive.view.ts?vue&type=script&lang=ts&"
import style0 from "./class-inactive.view.scss?vue&type=style&index=0&id=6a7a474c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7a474c",
  null
  
)

export default component.exports